import React,{ useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { updateUI } from "../../../store/actions/shipment";
import { Input, Select, DatePicker } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import BLEDetails from "./bleDetails";
import { IsRequiredValidation } from "./formValidation";
import utc from "dayjs/plugin/utc"; 
import {MAX_CHAR_LIMITS,getCharLimitMsgIfExceeded} from "../../../global/constants/inputLimits";
dayjs.extend(utc); 

function ShipmentCloneStep1() {
  const dispatch = useDispatch();
  const shipments = useSelector((state) => state?.shipment?.data?.deviceType);
  const deviceName = useSelector((state) => state?.shipment?.data?.deviceName);
  const shipmetProfile = useSelector((state) => state?.shipment?.data?.shipProfile);
  const filteredDevices = shipments?.devicetypes?.filter(device => device.devicemodel === "GAT");
  const selectedProfileId = useSelector((state) => state.shipment.ui.editShipment.selectedProfileId); 
  const tableData =filteredDevices; 
  const editField = useSelector((state) => {
    const key = Object.keys(state.shipment.ui.editShipment.editField?.profile?.value || {})
    return {
      ...state.shipment.ui.editShipment.editField,
    //  selectProfile: key.length > 0 ? state.shipment.ui.editShipment.editField?.selectProfile?.value[key[0]].label : "Select Profile",
    };
  });

  const { editRecord} = useSelector((state) => ({
    editRecord:state.shipment.ui.editShipment.editRecord,
  }));
  
  const devicetypeVal=shipments?.devicetypes;
  const handleDatePickerOk = () => {};

  const handleSelectProfile = () => {
    dispatch(
      updateUI({
        key: "editShipment",
        value: {
          step: 2,
        },
      })
    );
  };

  function getDeviceNameById(deviceId) {
    const device = deviceName?.devices?.find(
      (device) => device.uid === deviceId
    );
    return device ? device.name : null;
  }

  function getShipmentByid(profileid, key) {
    const item = shipmetProfile?.find(obj => obj.profileid === profileid);
    return item ? item[key] : null;
  }

  const handleFormField = (field, value) => {
    const validator = IsRequiredValidation(value);
    const updateObj = {
      ...editField,
      [field]: {
        ...validator,
        value,
      },
    };
    
    if (field === "deviceId" && value) {
      const selectedDeviceName = getDeviceNameById(value);

      if (selectedDeviceName) {
        updateObj.deviceName = {
          ...IsRequiredValidation(selectedDeviceName),
          value: selectedDeviceName,
        };

        updateObj.displayDeviceName = {
          ...IsRequiredValidation(selectedDeviceName),
          value: selectedDeviceName,
        };
      }
    }

    dispatch(
      updateUI({
        key: "editShipment",
        value: {
          editField: updateObj,
        },
      })
    );
  };

  useEffect(() => {
    if (editField?.deviceId?.value) {
      const currentDeviceId = editField.deviceId.value;
      const selectedDeviceName = getDeviceNameById(currentDeviceId);

      if (
        selectedDeviceName &&
        (!editField.deviceName ||
          editField.deviceName.value !== selectedDeviceName)
      ) {
        handleFormField("deviceName", selectedDeviceName);
      }
    }
  }, [editField?.deviceId?.value, deviceName?.devices]);

  return (
    <>
      <div className="py-1">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "20px",
          }}
        >
          Shipment details
        </div>
        <div className="d-flex flex-column justify-content-center align-items-start py-2 position-relative">
          <span>Shipment Name</span>
         <Input
  className={`shipment-form-fields ${editField?.shipmentName?.class}`}
  placeholder=""
  maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
  value={editField?.shipmentName?.value}
  onChange={(e) => {
    const raw = e.target.value;

    // ❌ Block space as the first character
    if (raw.length === 1 && raw === " ") {
      return;
    }

    // ✔ Allow spaces in the middle
    handleFormField("shipmentName", raw);
  }}
/>

          <span className={`${editField?.shipmentName?.class}-icon`}></span>
          {!editField?.shipmentName?.isValid && editField?.shipmentName?.error && <div className={`${editField?.shipmentName?.class}-msg`}>{editField?.shipmentName?.error}</div>}
          {getCharLimitMsgIfExceeded("CATEGORY_TEXT", editField?.shipmentName?.value)}
        </div>
        <div className="d-flex flex-column justify-content-center align-items-start py-2">
          <span>Start Date</span>
          <DatePicker
            key={"start-date"}
            className={`shipment-form-fields`}
            style={{
              width: "100%",
              height: "44px",
            }}
            format="MM-DD-YYYY HH:mm:ss"
            disabled={editField?.state?.value==="In Progress"?true:false}
            value={
              editField?.startDate?.value 
                ? dayjs(editField.startDate.value)
                : null
            }
            onChange={(val) => handleFormField("startDate", val)}
          //  onChange={(val) => handleFormField("startDate", dayjs.utc(val).format("YYYY-MM-DD HH:mm:ss"))}
            showTime
            allowClear={false}
            onOk={handleDatePickerOk}
          />
        </div>
      </div>

      <div className="py-1">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "20px",
          }}
        >
          Device details
        </div>
        <div className="d-flex flex-row justify-content-start align-items-center">
          <div className="w-50 me-3 d-flex flex-column justify-content-center align-items-start py-2">
            <span>Device Model</span>
            <Select
              className={`shipment-form-fields ${editField?.devicetype?.class}`}
              key={"device-type"}
              value={editField?.devicetype?.value}
              onChange={(val) => handleFormField("devicetype", val)}
              placeholder="Select device model"
              style={{
                width: "100%",
                height: "44px",
              }}
              options={[
                { value: "", label: "Select Device type" },
                ...(tableData?.map((item) => ({
                  value: item?.devicetype,
                  label: item?.devicetype,
                })) || []),
              ]}
            />
          </div>
          <div className="w-50 ml-3 d-flex flex-column justify-content-center align-items-start py-2">
            <span>Device Name</span>
            {deviceName?.devices === undefined ? (
              <div>Loading devices...</div>
            ) : (
              <Select
                className={`shipment-form-fields ${editField?.deviceId?.class}`}
                key={"device-Id"}
                value={editField?.deviceId?.value}
                onChange={(val) => handleFormField("deviceId", val)}
                style={{
                  width: "100%",
                  height: "44px",
                }}
                options={[
                  {key: "default",  value: "", label: "Select Device Name" },
                  ...(deviceName?.devices
                    ?.filter((item) => item?.kind === "ts.device.tgAssetTracker" && item?.customdata?.isAvailable===true || item?.uid === editRecord?.record?.deviceid)
                    ?.map((item) => ({
                      key: item?.uid, 
                      value: item?.uid,
                      label: item?.name,
                    })) || [])
                ]}
              />
            )}
          </div>
        </div>
        <div className="d-flex flex-column justify-content-center align-items-start py-2 position-relative">
          <span>Profile</span>
          <button
            onClick={handleSelectProfile}
            className={`shipment-clone-profile-button ${editField?.profile?.class}`}
          > 
          {editField?.selectProfile?.value?.name===undefined?
            (editField?.selectProfile?.value?.profilename || getShipmentByid(selectedProfileId, "profilename")) :
            editField?.selectProfile?.value?.name} <ArrowRightOutlined />
          </button>
        </div>
        <div className="d-flex flex-row justify-content-start align-items-center">
          <div className="w-50 me-3 d-flex flex-column justify-content-center align-items-start py-2">
            <span>Enable BLE Devices</span>  
            <Select
              className={`shipment-form-fields ${editField?.isBLEEnabled?.class}`}
              key={"enable-device-key"}
              value={editField?.isBLEEnabled?.value}
              onChange={(val) => {
                let isBLEEnabled = "no";
                if (val === "yes") {
                  isBLEEnabled = "yes";
                }
                handleFormField("isBLEEnabled", isBLEEnabled);
              }}
              style={{
                width: "100%",
                height: "44px",
              }}
              options={[
                {
                  value: "yes",
                  label: "Yes",
                },
                {
                  value: "no",
                  label: "No",
                },
              ]}
            />
          </div>
          <div className="w-50 ml-3 d-flex flex-column justify-content-center align-items-start py-2">
            <span>On shipment completion </span>
            <Select
              className={`shipment-form-fields ${editField?.onShipmentCompletion?.class}`}
              key={"on-shipment-competetion"}
              value={editField?.onShipmentCompletion?.value}
              onChange={(val) => handleFormField("onShipmentCompletion", val)}
              style={{
                width: "100%",
                height: "44px",
              }}
              options={[
                { value: "", label: "Select Profile" },
                ...(shipmetProfile?.map((item) => {
                  const matchingDevice = devicetypeVal?.find(
                    (device) =>
                      device?.devicetype === item?.devicetype && device?.devicemodel === "GAT" && item?.profiletype !== "nonshipment"
                  );
              if (matchingDevice) {
                    return {
                      value: item?.profileid,
                      label: item?.profilename,
                    };
                  }
                  return null; 
                }).filter(Boolean) || []),
              ]}
            />
          </div>
        </div>
      </div>
      {editField?.isBLEEnabled?.value==="yes" && (
        <div className="py-1">
          <BLEDetails />
        </div>
      )}

      <div className="py-1">
        <div
          className="font-face-vzw"
          style={{
            fontWeight: 700,
            fontSize: "20px",
          }}
        >
          Additional details
        </div>
        <div className="d-flex justify-content-start align-items-center py-2">
          <div className="w-50 me-3 d-flex flex-column justify-content-center align-items-start position-relative">
            <span>Product ID</span>
            <Input
              className={`shipment-form-fields`}
              value={editField?.productId?.value}
              onChange={(e) => handleFormField("productId", e?.target?.value)}
               maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
            />
            {getCharLimitMsgIfExceeded("CATEGORY_TEXT", editField?.productId?.value)}
          </div>
          <div className="w-50 ml-3 d-flex flex-column justify-content-center align-items-start position-relative">
            <span>Product Serial Number</span>
            <Input
              className={`shipment-form-fields`}
              value={editField?.productSerialNumber?.value}
               maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
              onChange={(e) =>
                handleFormField("productSerialNumber", e?.target?.value)
              }
            />
            {getCharLimitMsgIfExceeded("CATEGORY_TEXT", editField?.productSerialNumber?.value)}
          </div>
        </div>
        <div className="d-flex justify-content-start align-items-center py-2 ">
          <div className="w-50 me-3 d-flex flex-column justify-content-center align-items-start position-relative">
            <span>Tracking Number</span>
            <Input
              className={`shipment-form-fields`}
              value={editField?.trackingNumber?.value}
               maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
              onChange={(e) =>
                handleFormField("trackingNumber", e?.target?.value)
              }
            />
            {getCharLimitMsgIfExceeded("CATEGORY_TEXT", editField?.trackingNumber?.value)}
          </div>
          <div className="w-50 ml-3 d-flex flex-column justify-content-center align-items-start position-relative">
            <span>Order Number</span>
            <Input
              className={`shipment-form-fields`}
              value={editField?.orderNumber?.value}
               maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
              onChange={(e) => handleFormField("orderNumber", e?.target?.value)}
            />
            {getCharLimitMsgIfExceeded("CATEGORY_TEXT", editField?.orderNumber?.value)}
          </div>
        </div>
        <div className="d-flex justify-content-start align-items-center py-2">
          <div className="w-50 me-3 d-flex flex-column justify-content-center align-items-start position-relative">
            <span>Customer Name</span>
            <Input
              className={`shipment-form-fields`}
              value={editField?.customerName?.value}
               maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
              onChange={(e) =>
                handleFormField("customerName", e?.target?.value)
              }
            />
            {getCharLimitMsgIfExceeded("CATEGORY_TEXT", editField?.customerName?.value)}
          </div>
          <div className="w-50 ml-3 d-flex flex-column justify-content-center align-items-start position-relative">
            <span>PO Number</span>
            <Input
              className={`shipment-form-fields`}
              value={editField?.poNumber?.value}
               maxLength={MAX_CHAR_LIMITS.CATEGORY_TEXT}
              onChange={(e) => handleFormField("poNumber", e?.target?.value)}
            />
            {getCharLimitMsgIfExceeded("CATEGORY_TEXT", editField?.poNumber?.value)}
          </div>
        </div>
      </div>
    </>
  );
}

export default ShipmentCloneStep1;
